"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteEventArgs = exports.SaveEventArgs = exports.CellEventArgs = void 0;
const _ = __importStar(require("lodash"));
class RowEventArgs {
    $$waitfor;
    row;
    sender;
    table;
    constructor(row, table) {
        this.row = row;
        this.sender = table;
        this.table = table;
        this.$$waitfor = [];
    }
    waitFor(awaitable) {
        this.$$waitfor.push(awaitable);
    }
    whenReady() {
        return new Promise((resolve, reject) => setTimeout(() => this.sender
            .$nextTick()
            .then(() => Promise.all(this.$$waitfor))
            .then(results => _.last(_.filter(results, p => !!p)))
            .then(resolve)
            .catch(reject), 100));
    }
}
class CellEventArgs extends RowEventArgs {
    col;
    constructor(row, col, table) {
        super(row, table);
        this.col = col;
    }
}
exports.CellEventArgs = CellEventArgs;
class SaveEventArgs extends RowEventArgs {
}
exports.SaveEventArgs = SaveEventArgs;
class DeleteEventArgs extends RowEventArgs {
}
exports.DeleteEventArgs = DeleteEventArgs;
//# sourceMappingURL=eventargs.js.map